// src/components/shared/NavBar.js
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useAuth } from '../../context/AuthContext';
import crest from '../../assets/crest.png';

const NAVY = '#1B3A6B';
const GOLD = '#C9A84C';

export default function NavBar({ subtitle }) {
  const navigate        = useNavigate();
  const { role, member } = useAuth();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  const navLinks = [
    { label: '🏠 Dashboard',     path: '/dashboard' },
    { label: '👤 Profile',        path: '/profile' },
    { label: '👥 Directory',      path: '/directory' },
    { label: '💰 Dues',           path: '/dues' },
    { label: '📢 Announcements',  path: '/announcements' },
    { label: '🖼️ Activities',     path: '/activities' },
    { label: '🤝 Opportunities',  path: '/opportunities' },
    { label: '🎯 Fundraising',    path: '/fundraising' },
    ...(role === 'treasurer' || role === 'executive'
      ? [{ label: '💳 Payments', path: '/payments/enter' }]
      : []),
    ...(role === 'executive' || role === 'treasurer'
      ? [{ label: '📊 Dashboard', path: '/exec-dashboard' }]
      : []),
    ...(role === 'executive'
      ? [{ label: '⚙️ Members', path: '/admin/members' }]
      : []),
  ];

  return (
    <nav style={{
      background: NAVY,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      position: 'sticky', top: 0, zIndex: 1000
    }}>
      {/* Main nav row */}
      <div style={{
        padding: '0 24px', height: '60px',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '1200px', margin: '0 auto'
      }}>
        {/* Logo */}
        <div
          onClick={() => navigate('/dashboard')}
          style={{
            display: 'flex', alignItems: 'center',
            gap: '12px', cursor: 'pointer', flexShrink: 0
          }}
        >
          <img
            src={crest}
            alt="Achimota Crest"
            style={{
              width: '36px', height: '36px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: `2px solid ${GOLD}`
            }}
          />
          <div>
            <div style={{
              color: '#fff', fontWeight: 'bold', fontSize: '14px'
            }}>
              Achimota 1992
            </div>
            <div style={{ color: GOLD, fontSize: '11px' }}>
              {subtitle || 'Alumni Portal'}
            </div>
          </div>
        </div>

        {/* Right side — member name + sign out */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: '16px'
        }}>
          {member?.name && (
            <span style={{
              color: 'rgba(255,255,255,0.75)',
              fontSize: '13px',
              display: window.innerWidth > 600 ? 'block' : 'none'
            }}>
              {member.name.split(' ')[0]}
            </span>
          )}
          <button
            onClick={handleLogout}
            style={{
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.4)',
              color: '#fff', padding: '6px 16px',
              borderRadius: '6px', cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Secondary nav links row */}
      <div style={{
        background: 'rgba(0,0,0,0.2)',
        overflowX: 'auto',
        whiteSpace: 'nowrap'
      }}>
        <div style={{
          padding: '0 24px',
          maxWidth: '1200px', margin: '0 auto',
          display: 'flex', gap: '4px'
        }}>
          {navLinks.map(link => {
            const isActive =
              window.location.pathname === link.path;
            return (
              <button
                key={link.path}
                onClick={() => navigate(link.path)}
                style={{
                  background: isActive
                    ? 'rgba(255,255,255,0.15)' : 'transparent',
                  border: 'none',
                  borderBottom: isActive
                    ? `2px solid ${GOLD}` : '2px solid transparent',
                  color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
                  padding: '8px 12px',
                  cursor: 'pointer', fontSize: '12px',
                  fontWeight: isActive ? '600' : 'normal',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.15s'
                }}
                onMouseEnter={e => {
                  if (!isActive) {
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.background =
                      'rgba(255,255,255,0.1)';
                  }
                }}
                onMouseLeave={e => {
                  if (!isActive) {
                    e.currentTarget.style.color =
                      'rgba(255,255,255,0.7)';
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                {link.label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}